export const transformPrice = (price: string) => {
	let commaPosition = price.lastIndexOf(',');
	let finalString: string = price.substr(0, commaPosition + 1);

	for (let index = commaPosition + 1; index <= price.length - 1; index++) {
		finalString = finalString + price.charAt(index).fontsize(4);
	}
	return finalString;
};
